import { TagComboBoxModel } from '../tag-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * タグ情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class KYMW68GetTagListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class KYMW68GetTagListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: TagComboBoxModel;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof KYMW68GetTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param {TagComboBoxModel} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof KYMW68GetTagListService
   */
  execute(model: TagComboBoxModel, successFunc: () => void = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW68getTagList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof KYMW68GetTagListService
   */
  success(data: any) {
    if (data !== null) {
      this.model.updateTagList(data.TagList);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
